'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var Typography = require('../../Base/Typography/Typography.js');
require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

const PaginationNumber = (_a)=>{
    var { value, enabled } = _a, rest = _tslib.__rest(_a, [
        "value",
        "enabled"
    ]);
    return jsxRuntime.jsx("button", Object.assign({
        className: tailwindMerge.twMerge('flex size-10 justify-center rounded-xl p-2 text-w-gray-700', enabled ? 'bg-primary-50 text-primary' : 'hover:bg-w-gray-50')
    }, rest, {
        children: jsxRuntime.jsx(Typography, {
            variant: "body2",
            children: value
        })
    }));
};
const LeftArrow = (props)=>{
    return jsxRuntime.jsx("button", Object.assign({}, props, {
        "data-testid": "design-system-pagination-left-arrow",
        children: jsxRuntime.jsx(SystemIcon, {
            name: "medium_arrow_left",
            className: "text-w-gray-900"
        })
    }));
};
const RightArrow = (props)=>{
    return jsxRuntime.jsx("button", Object.assign({}, props, {
        "data-testid": "design-system-pagination-right-arrow",
        children: jsxRuntime.jsx(SystemIcon, {
            name: "medium_arrow_right",
            className: "text-w-gray-900"
        })
    }));
};

exports.LeftArrow = LeftArrow;
exports.PaginationNumber = PaginationNumber;
exports.RightArrow = RightArrow;
